import { render } from "./MarketingNave.vue?vue&type=template&id=2459d1a6&scoped=true"
import script from "./MarketingNave.vue?vue&type=script&lang=js"
export * from "./MarketingNave.vue?vue&type=script&lang=js"

import "./MarketingNave.vue?vue&type=style&index=0&id=2459d1a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2459d1a6"]])

export default __exports__